/**
 * Returns base URL for the Help Center
 */
export const getHelpCenterBaseUrl = (): string => "https://support.portal.flexport.com/hc/en-us";
